<template>
  <div>
    <v-toolbar flat color="white" dense style="margin-bottom:0px">
      <v-btn
        color="red"
        class="white--text"
        :disabled="selectedOrders.length == 0"
        small
        @click="markDelivered()"
        >Mark as delivered</v-btn
      >
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <div style="width:200px;">
        <v-text-field
          v-model="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      v-model="selectedOrders"
      :items="orders"
      :search="search"
      :loading="true"
      item-key="id"
      dense
      select-all="primary"
      class="elevation-1 orders-table"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="headerCell" slot-scope="{ header }">
        <div
          class="subheading font-weight-light text-primary text--darken-3"
          v-text="header.text"
        />
        <div class="font-weight-light text--darken-4" v-text="header.desc" />
      </template>

      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox
            v-model="props.selected"
            color="primary"
            hide-details
          ></v-checkbox>
        </td>
        <td>
          {{ props.item.tracking_id }}
        </td>
        <td>
          <table>
            <tr :key="itm.id" v-for="itm in props.item.items">
              <td :rowspan="itm.variants.length || 1">
                {{ itm.name }} <br />
                <small class="grey--text">
                  Price: Rs. {{ discountedPrice(itm) }}
                </small>
              </td>
              <td v-if="!itm.variants.length" :colspan="3"></td>
              <template v-for="v in itm.variants">
                <td :key="v.id + 'a'">{{ v.label }}</td>
                <td :key="v.id + 'b'">{{ v.value.name }}</td>
                <td :key="v.id + 'c'">{{ v.value.price }}</td>
              </template>
              <td :rowspan="itm.variants.length || 1">
                {{ itm.quantity }}
              </td>
              <td :rowspan="itm.variants.length || 1">
                Rs. {{ itm.quantity * discountedPrice(itm) }}
              </td>
            </tr>
          </table>
        </td>
        <td>
          {{ props.item.address.name }} <br />
          {{ props.item.address.house_number }} <br />
          {{ props.item.address.apartment }} <br />
          {{ props.item.address.area }} <br />
          {{ props.item.address.city }} - {{ props.item.address.pincode }}
          <br />
          Phone - {{ props.item.address.phone }} <br />
        </td>
        <td class="text-xs-center">{{ props.item.payment_method }}</td>
        <td class="text-xs-right">
          <strong>Rs. {{ props.item.grand_total }}</strong>
        </td>
        <td class="text-xs-center text-no-wrap">
          {{ new Date(props.item.date).toLocaleDateString() }}
        </td>
        <td class="text-xs-center text-no-wrap">
          {{
            props.item.delivery_date
              ? new Date(props.item.delivery_date).toLocaleDateString()
              : '-'
          }}
        </td>
        <td
          class="text-xs-center text-no-wrap"
          v-if="config.type === 'grocery'"
        >
          {{ props.item.delivery_time_slot }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script type="text/javascript">
export default {
  data() {
    return {
      search: '',
      selectedOrders: [],
      headers: [],
      dialog: false,
    };
  },
  props: ['orders'],
  methods: {
    al: function() {
      alert('hello');
    },
    markDelivered() {
      var ids = [];
      this.selectedOrders.forEach(i => {
        ids.push(i.id);
      });
      this.$emit('markDelivered', { order_ids: ids });
      this.selectedOrders = [];
    },
  },
  computed: {
    config() {
      return this.$store.getters.config;
    },
  },
  created() {
    this.headers = [
      {
        sortable: false,
        text: 'Order Id',
        value: 'id',
      },
      {
        sortable: false,
        text: 'Items',
        value: 'items',
        desc: 'Name Label Qty Price',
      },
      {
        sortable: false,
        text: 'Buyer Details',
        value: 'address',
      },
      {
        sortable: false,
        text: 'Payment Mode',
        value: 'payment_mode',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Amount',
        value: 'total',
        align: 'center',
        desc: 'subtotal + extra charges',
      },
      {
        sortable: false,
        text: 'Date',
        value: 'created',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Dispatch By',
        value: 'delivery_date',
        align: 'center',
      },
    ];
    if (this.config.type === 'grocery')
      this.headers.push({
        sortable: false,
        text: 'Time Slot',
        value: 'delivery_time_slot',
        align: 'center',
      });
  },
};
</script>
